import { SgSessionStorageService } from 'saga-modules';

let stepsToSkip;

function step(stepId) {
    return {
        skipIf: (cond) => {
            if (cond()) {
                stepsToSkip.push(stepId);
            }
        }
    };
}

export default function RenewalWizardSkipConfig(renewalVM, isInitialCheck) {
    stepsToSkip = [];
    const renewal = renewalVM.value;

    const renewalAddonsPageAvailable = SgSessionStorageService.getItem(SgSessionStorageService.KEY.CEP_RENEWAL_ADDONS_PAGE_AVAILABLE);
    step('RenewalAddons')
        .skipIf(() => {
            if (isInitialCheck) {
                return false;
            }
            return !renewalAddonsPageAvailable;
        });

    step('RenewalChanges')
        .skipIf(() => {
            if (isInitialCheck) {
                return false;
            }
            return renewalAddonsPageAvailable || (renewal.renewalDetails && renewal.renewalDetails.isAmendingRenewal !== true);
        });

    step('RenewalQuote')
        .skipIf(() => {
            return renewal.renewalDetails && renewal.renewalDetails.isAmendingRenewal !== true;
        });

    return stepsToSkip;
}
